<template>
  <div>

    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>

    <el-card>
      <el-form
        ref="registrationForm"
        :model="formData"
        :rules="rules"
        :label-width="$root.labelWidth"
        label-position="right"
        v-loading="registering"
      >

        <el-form-item :label="$t('modules.company.fields.name.label')" prop="companyName">
          <el-input type="text" v-model.lazy.trim="formData.company_attributes.name" :placeholder="$t('modules.company.fields.name.placeholder')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('modules.user.fields.email.label')" prop="email">
          <el-input type="email" v-model.lazy.trim="formData.email" :placeholder="$t('modules.user.fields.email.placeholder')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('modules.user.fields.password.label')" prop="password">
          <el-input type="password" v-model.lazy.trim="formData.password" :placeholder="$t('modules.user.fields.password.placeholder')"></el-input>
        </el-form-item>

        <el-form-item :label="$t('modules.user.fields.passwordConfirmation.label')" prop="passwordConfirmation">
          <el-input type="password" v-model.lazy.trim="formData.password_confirmation" :placeholder="$t('modules.user.fields.passwordConfirmation.placeholder')"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('registrationForm')">{{ $t('buttons.submit') }}</el-button>
          <p><router-link :to="{ name: 'home' }"><a>{{ $t(`${translationPrefix}.buttons.haveAccount`) }}</a></router-link></p>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';
  import validations from '@/utils/validations';

  export default {
    name: 'RegistrationPage',
    data() {
      return {
        translationPrefix: 'pages.registration',
        rules: {
          email: [
            { ...validations.required },
            { ...validations.email },
          ],
          password: [
            { ...validations.required },
          ],
          password_confirmation: [
            { ...validations.required },
          ],
          company_attributes: {
            name: [
              { ...validations.required },
            ],
          },
        },
        formData: {
          email: '',
          password: '',
          password_confirmation: '',
          company_attributes: {
            name: '',
          },
        },
      };
    },
    computed: {
      ...mapGetters('entities/users/', ['registering']),
      locale() {
        return this.$store.getters.locale;
      },
    },
    methods: {
      submitForm(formName) {
        const self = this;

        self.$refs[formName].validate((valid) => {
          if (valid) {
            self.$store.dispatch('entities/users/register', { ...self.formData, locale: self.locale })
              .then((response) => {
                if (response.status) {
                  showSuccessMessage(self.$t('modules.user.messages.registered'));

                  self.$router.push('/dashboard');
                } else {
                  showErrorMessage(response.error);
                }
              });
          } else {
            showErrorMessage(self.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },
    },
  };
</script>




// WEBPACK FOOTER //
// src/pages/Registration.vue